import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
export default {
  name: 'merchant-profile',
  components: {},
  props: [],
  data() {
    return {
      modalShow: false,
      btntext: '',
      updatemerchantmodal: false,
      editmerchantmodal: false,
      addmerchantmodal: false,
      merchantaction: '',
      listCompanyData: [],
      listStateData: [],
      listCityData: [],
      merchantid: '',
      pageno: 0,
      pagecount: 0,
      merchantname: '',
      merchantid: '',
      status: '',
      model: {
        name: '',
        username: ''
      },
      addmerchant: {
        merchantname: '',
        businesstype: '',
        merchantpersonemail: '',
        merchantaddress: '',
        merchantaddress2: '',
        country: '',
        merchantstate: '',
        city: '',
        pincode: '',
        merchantpersonname: '',
        merchantpersonmobile: '',
        merchantpersonphone: '',
        merchantregisternum: '',
        merchantpanid: '',
        merchantgstnum: '',
        merchantloginemail: '',
        password: ''
      }

    }
  },
  computed: {

  },
  mounted() {

    // var logindata=JSON.parse(localStorage.getItem('userdetail'));
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.merchantid = userdetail.userid;
    this.getsingleMerchantData()
    this.getStateList()

  },
  methods: {
    getsingleMerchantData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        loginuserid: this.merchantid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'GetSingleMerchantData',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.addmerchant = result['data']['dataset'][0]
          this.addmerchant.merchantstate = this.addmerchant.state
          this.addmerchant.merchantcity = this.addmerchant.city
          this.getCityList();

        }, error => {
          console.error(error)
        })
    },

    getStateList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stateList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })

        .then(result => {
          this.listStateData = result.data

        }, error => {
          console.error(error)
        })
    },

    saveMerchant() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateMerchant',
          'data': {
            'merchantid': this.merchantid,
            'merchantname': this.addmerchant.merchantname,
            'businesstype': this.addmerchant.businesstype,
            'merchantname': this.addmerchant.merchantname,
            'merchantaddress': this.addmerchant.merchantaddress,
            'merchantaddress2': this.addmerchant.merchantaddress2,
            'city': this.addmerchant.merchantcity,
            'state': this.addmerchant.merchantstate,
            'country': this.addmerchant.country,
            'merchantpanid': this.addmerchant.merchantpanid,
            'merchantgstnum': this.addmerchant.merchantgstnum,
            'merchantregisternum': this.addmerchant.merchantregisternum,
            'merchantpersonname': this.addmerchant.merchantpersonname,
            'merchantpersonemail': this.addmerchant.merchantpersonemail,
            'merchantpersonphone': this.addmerchant.merchantpersonphone,
            'merchantpersonmobile': this.addmerchant.merchantpersonmobile,
            'userid': 15,
            'pincode': this.addmerchant.merchantpincode
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.msg == 1) {
            this.$alertify.success("Merchant Created Successfully")
            this.addmerchantmodal = false
          } else {
            (response.data.msg == 2)
            this.$alertify.error("Merchant already existed")
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },


    getCityList() {
      //debugger
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        "statename": this.addmerchant.merchantstate
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cityList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listCityData = result.data

        }, error => {
          console.error(error)
        })
    },


    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }

  },





}


// WEBPACK FOOTER //
// ./src/views/components/merchantProfile/merchantProfile.component.js